import { DriveThemeStyleDefinition, HeyDriveType, resolveTheme } from '@/models/drive.ts'

export default interface FontDetails {
  font: string
  font_content: string
}

export interface FontDefinition {
  id: string
  css: string
  display: string
  serif: boolean
  multiplier?: number
}

export const allFonts: Array<FontDefinition> = [
  {
    id: 'nunito',
    css: 'Nunito',
    display: 'Nunito',
    serif: false,
  },
  {
    id: 'gambetta',
    css: 'Gambetta',
    display: 'Gambetta',
    serif: true,
  },
  // {
  //   id: 'astagina-signature',
  //   css: 'Astagina Signature',
  //   display: 'Astagina Signature',
  //   serif: true,
  //   multiplier: 1.75,
  // },
  {
    id: 'cormorant-infant',
    css: 'Cormorant Infant',
    display: 'Cormorant Infant',
    serif: true,
  },
  {
    id: 'boska',
    css: 'Boska',
    display: 'Boska',
    serif: true,
  },
  {
    id: 'bonny',
    css: 'Bonny',
    display: 'Bonny',
    serif: false,
  },
  {
    id: 'telma',
    css: 'Telma',
    display: 'Telma',
    serif: false,
  },
  {
    id: 'bespoke-serif',
    css: 'Bespoke Serif',
    display: 'Bespoke Serif',
    serif: true,
  },
  {
    id: 'stardom',
    css: 'Stardom',
    display: 'Stardom',
    serif: false,
  },
  {
    id: 'chubbo',
    css: 'Chubbo',
    display: 'Chubbo',
    serif: false,
  },
  {
    id: 'cabinet-grotesk',
    css: 'Cabinet Grotesk',
    display: 'Cabinet Grotesk',
    serif: false,
  },
  {
    id: 'pencerio',
    css: 'Pencerio',
    display: 'Pencerio',
    serif: true,
  },
  {
    id: 'satoshi',
    css: 'Satoshi',
    display: 'Satoshi',
    serif: false,
  },
  {
    id: 'montserrat',
    css: 'Montserrat',
    display: 'Montserrat',
    serif: false,
  },
  {
    id: 'dancing-script',
    css: 'Dancing Script',
    display: 'Dancing Script',
    serif: true,
  },
  {
    id: 'synonym',
    css: 'Synonym',
    display: 'Synonym',
    serif: false,
  },
  {
    id: 'supreme',
    css: 'Supreme',
    display: 'Supreme',
    serif: false,
  },
  {
    id: 'lora',
    css: 'Lora',
    display: 'Lora',
    serif: true,
  },
  {
    id: 'fira-sans',
    css: 'Fira Sans',
    display: 'Fira Sans',
    serif: false,
  },
  {
    id: 'rosaline',
    css: 'Rosaline',
    display: 'Rosaline',
    serif: true,
  },
  {
    id: 'work-sans-variable',
    css: 'Work Sans Variable',
    display: 'Work Sans Variable',
    serif: false,
  },
  {
    id: 'poppins',
    css: 'Poppins',
    display: 'Poppins',
    serif: false,
  },
  {
    id: 'sentient',
    css: 'Sentient',
    display: 'Sentient',
    serif: true,
  },
  {
    id: 'general-sans',
    css: 'General Sans',
    display: 'General Sans',
    serif: false,
  },
  {
    id: 'public-sans',
    css: 'Public Sans',
    display: 'Public Sans',
    serif: false,
  },
  {
    id: 'britney',
    css: 'Britney',
    display: 'Britney',
    serif: true,
  },
  {
    id: 'zodiak',
    css: 'Zodiak',
    display: 'Zodiak',
    serif: true,
  },
  {
    id: 'melodrama',
    css: 'Melodrama',
    display: 'Melodrama',
    serif: true,
  },
  {
    id: 'gambarino',
    css: 'Gambarino',
    display: 'Gambarino',
    serif: true,
  },
]

export function getFontDefinitionById(id: string) {
  return allFonts.find(definition => definition.id === id)
}

export const sansSerifFonts = allFonts.filter(font => !font.serif)
export const serifFonts = allFonts.filter(font => font.serif)

export const defaultFont = getFontDefinitionById('gambetta')!
export const defaultFontContent = getFontDefinitionById('nunito')!

export interface FontDuo {
  font: FontDefinition
  font_content: FontDefinition
}

export interface Fontable {
  font: string
  font_content: string
}

export function getFontDuoForFontable(fontable: Fontable, theme_name: string, drive_type: HeyDriveType): FontDuo {
  let theme: DriveThemeStyleDefinition | null = null
  if (drive_type == HeyDriveType.PROF) {
    theme =  resolveTheme(theme_name, drive_type)
  }
  const themeDefaultFont = theme?.font_header ? (getFontDefinitionById(theme.font_header) || defaultFont) : defaultFont
  const themeDefaultFontContent = theme?.font_content ? (getFontDefinitionById(theme.font_content) || defaultFontContent) : defaultFontContent

  return {
    font: fontable.font ? (getFontDefinitionById(fontable.font) || themeDefaultFont) : themeDefaultFont,
    font_content: fontable.font_content ? (getFontDefinitionById(fontable.font_content) || themeDefaultFontContent) : themeDefaultFontContent,
  }
}

